import { Link as CLink, LinkProps } from "@chakra-ui/react";
import Link from "next/link";

/**
 * - Reset all link decoration default like border or underline
 * - It used next js link component behind the scene and wrap it with chakra link component
 * - so we can styling it with chakra ui and also have all benefits of next js link
 * @param props
 * @returns
 */
export const NextLink = (props: LinkProps) => {
  return (
    <CLink as={Link} border={0} textDecor="none" outline="none" {...props}>
      {props.children}
    </CLink>
  );
};
